import React, { useEffect, useState } from "react"
import { Card, CardBody } from "reactstrap"
import { useClientContext } from "../ClientContextBox"
import LoadingButton from "components/Common/LoadingButton"
import { axiosbaseurl } from "configure"
import moment from "moment"
import ServiceDateCalculate from "../components/ServiceDateCalculate"

const BookeepingManagement = ({ changeStep, client_id }) => {
  const {
    clientId,
    isReadOnly,
    setErrors,
    errors,
    clientName,
    bookkeepingFirstPeriodEnd,
    setBookkeepingFirstPeriodEnd,
    bookkeepingFrequency,
    setBookkeepingFrequency,
    bookkeepingCurrentPeriodEnd,
    setBookkeepingCurrentPeriodEnd,
    bookkeepingCurrentPeriodDueDate,
    setBookkeepingCurrentPeriodDueDate,
    isBookkeepingPresent,
    setBookkeepingPresent,

    managementAccountFirstPeriodEnd,
    setManagementAccountFirstPeriodEnd,
    managementAccountFrequency,
    setManagementAccountFrequency,
    managementAccountCurrentPeriodEndDate,
    setManagementAccountCurrentPeriodEndDate,
    managementAccountCurrentPeriodDueDate,
    setManagementAccountCurrentPeriodDueDate,
    isMAPresent,
    setMAPresent,

    confirmCurrentYearDueDate,
    setConfirmCurrentYearDueDate,
    confirmCSYearDueDate,
    setConfirmCSYearDueDate,
    static_frequency,

    currentKyc,
    setCurrentKyc,
    kycDuration,
    setKycDuration,
    nextKyc,
    setNextKyc,

    setIsChanged,
  } = useClientContext()

  const [loading, setLoading] = useState(false)

  const validate = () => {
    let tempErrors = {}

    // if (!bookkeepingFirstPeriodEnd) tempErrors.bookkeepingFirstPeriodEnd = "Bookeeping is required."
    // if (!bookkeepingFrequency)
    //   tempErrors.bookkeepingFrequency = "Frequency is required."
    // if (!managementAccountFirstPeriodEnd)
    //   tempErrors.managementAccountFirstPeriodEnd = "Manage Account is required."
    // if (!managementAccountFrequency)
    //   tempErrors.managementAccountFrequency = "Frequency is required."

    if (!currentKyc) tempErrors.currentKyc = "Recent KYC is required."
    if (!kycDuration) tempErrors.kycDuration = "Frequency is required."

    setErrors(tempErrors)
    return Object.keys(tempErrors).length === 0
  }

  const handleSubmit = async () => {
    if (validate() && !isReadOnly) {
      // if (true) {

      swal({
        title: "Are you sure?",
        text: `You want to save this details to ${clientName}.`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async willDelete => {
        if (willDelete) {
          try {
            setLoading(true)

            const post_data = {
              bookkeepingFirstPeriodEnd,
              bookkeepingFrequency,
              bookkeepingCurrentPeriodEnd,
              bookkeepingCurrentPeriodDueDate,

              managementAccountFirstPeriodEnd,
              managementAccountFrequency,
              managementAccountCurrentPeriodEndDate,
              managementAccountCurrentPeriodDueDate,

              CScurrentYearDueDate: confirmCurrentYearDueDate,
              currentCSYearDueDate: confirmCSYearDueDate,

              currentKYCDueDate: currentKyc,
              KYCFrequency: kycDuration,
              nextKYCDueDate: nextKyc,
            }

            const response = await axiosbaseurl.put(
              `/client/${clientId || client_id}`,
              post_data
            )

            if (response.data.success) {
              // setClientId(response.data.data.id)
              setIsChanged(prev => ({ ...prev, 4: false }))
              swal("", "Details saved successfully", "success").then(() => {
                changeStep()
              })
            }
          } catch (error) {
            console.log(error)
            const msg =
              error.response.data.message ||
              error.message ||
              "Something went Wrong"

            swal(
              "",
              msg,
              msg.includes("No changes were made !") ? "warning" : "error"
            )
          } finally {
            setLoading(false)
          }
        }
      })
    } else {
      window.scrollTo(0, 150)
    }
  }

  // calculate next kyc date
  useEffect(() => {
    if (currentKyc && kycDuration) {
      const calculateNextKyc = () => {
        const date = new Date(currentKyc)
        // Add the selected frequency (in years) to the current date
        date.setFullYear(date.getFullYear() + parseInt(kycDuration))
        setNextKyc(moment(date).format("YYYY-MM-DD")) // Set the next KYC due date in YYYY-MM-DD format
      }
      calculateNextKyc()
    } else {
      setNextKyc("")
    }
  }, [currentKyc, kycDuration])

  return (
    <div>
      <ServiceDateCalculate
        firstPeriodEnd={bookkeepingFirstPeriodEnd}
        setFirstPeriodEnd={setBookkeepingFirstPeriodEnd}
        frequency={bookkeepingFrequency}
        setFrequency={setBookkeepingFrequency}
        currentPeriodEnd={bookkeepingCurrentPeriodEnd}
        setCurrentPeriodEnd={setBookkeepingCurrentPeriodEnd}
        currentPeriodDue={bookkeepingCurrentPeriodDueDate}
        setCurrentPeriodDue={setBookkeepingCurrentPeriodDueDate}
        mainheading="Bookkeeping"
        label1={"Bookkeeping First Period End"}
        label2={"Frequency"}
        label3={"Current Period End"}
        label4={"Current Period Due Date"}
        static_frequency={static_frequency.slice(0, 2)}
        isReadOnly={isReadOnly}
        datePresent={isBookkeepingPresent}
        setDatePresent={setBookkeepingPresent}
      />

      <ServiceDateCalculate
        firstPeriodEnd={managementAccountFirstPeriodEnd}
        setFirstPeriodEnd={setManagementAccountFirstPeriodEnd}
        frequency={managementAccountFrequency}
        setFrequency={setManagementAccountFrequency}
        currentPeriodEnd={managementAccountCurrentPeriodEndDate}
        setCurrentPeriodEnd={setManagementAccountCurrentPeriodEndDate}
        currentPeriodDue={managementAccountCurrentPeriodDueDate}
        setCurrentPeriodDue={setManagementAccountCurrentPeriodDueDate}
        mainheading="Management Accounts"
        label1={"MA First Period End"}
        label2={"Frequency"}
        label3={"Current Period End"}
        label4={"Current Period Due Date"}
        static_frequency={static_frequency.slice(0, 2)}
        isReadOnly={isReadOnly}
        datePresent={isMAPresent}
        setDatePresent={setMAPresent}
      />

      <Card>
        <CardBody>
          <div className="row">
            <h4 className="fw-bold mb-4">Confirmation Statement</h4>

            <div className="col-md-4 mb-md-1 mb-3">
              <label>CS Current Year</label>
              <input
                type="date"
                value={confirmCurrentYearDueDate}
                // onChange={(e) => setManagementAccountFirstPeriodEnd(e.target.value)}
                className="form-control input-field"
                readOnly
              />
            </div>

            <div className="col-md-4 mb-md-1 mb-3">
              <label>CS Due Date</label>
              <input
                type="date"
                value={confirmCSYearDueDate}
                // onChange={(e) => setManagementAccountFirstPeriodEnd(e.target.value)}
                className="form-control input-field"
                readOnly
              />
            </div>
          </div>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <div className="row">
            <h4 className="fw-bold mb-4">KYC</h4>

            <div className="col-md-4 mb-md-1 mb-3">
              <label>
                Most Recent KYC <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                value={currentKyc}
                onChange={e => setCurrentKyc(e.target.value)}
                disabled={isReadOnly}
                className="form-control input-field"
              />
              <span className="error">{errors.currentKyc}</span>
            </div>

            <div className="col-md-4 mb-md-1 mb-3">
              <label>
                Frequency amount <span className="text-danger">*</span>
              </label>
              <select
                className="form-select input-field"
                disabled={isReadOnly}
                value={kycDuration}
                onChange={e => setKycDuration(e.target.value)}
              >
                <option value="">Select Frequency</option>
                {[1, 2, 3]?.map(option => (
                  <option key={option} value={option}>
                    {option} Year
                  </option>
                ))}
              </select>
              <span className="error">{errors.kycDuration}</span>
            </div>

            <div className="col-md-4 mb-md-1 mb-3">
              <label>Next KYC Due</label>
              <input
                type="date"
                value={nextKyc}
                onChange={e => setNextKyc(e.target.value)}
                // disabled={isReadOnly}
                readOnly
                className="form-control input-field"
              />
            </div>
          </div>
        </CardBody>
      </Card>

      {!isReadOnly ? (
        <Card>
          <CardBody>
            <LoadingButton
              loading={loading}
              btnText="Save & Next"
              icon_2={<i className="fas fa-arrow-right ms-3"></i>}
              handler={handleSubmit}
            />
          </CardBody>
        </Card>
      ) : null}
    </div>
  )
}

export default BookeepingManagement
